// extracted by mini-css-extract-plugin
module.exports = {"responseTimeTable":"responseTime_responseTimeTable__WPOFR"};